import React from 'react';
import { DataProvider } from '@components/DataProvider';
import '@styles/global.scss';

export function wrapPageElement({ element, props }) {
  return <DataProvider value={props}>{element}</DataProvider>;
}
